/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from 'relay-runtime';
declare export opaque type ProductCharacteristics_product$ref: FragmentReference;
export type ProductCharacteristics_product = {|
  +category: {|
    +characteristicKeys: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +key: ?string,
        |},
      |}>,
    |},
  |},
  +characteristics: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +key: {|
          +key: ?string,
        |},
        +value: ?string,
      |},
    |}>,
  |},
  +$refType: ProductCharacteristics_product$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "key",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Fragment",
  "name": "ProductCharacteristics_product",
  "type": "Product",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "category",
      "storageKey": null,
      "args": null,
      "concreteType": "Category",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "characteristicKeys",
          "storageKey": null,
          "args": null,
          "concreteType": "CharacteristicKeyConnection",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "CharacteristicKeyEdge",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "CharacteristicKey",
                  "plural": false,
                  "selections": v0
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "characteristics",
      "storageKey": null,
      "args": null,
      "concreteType": "CharacteristicValueConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "CharacteristicValueEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "CharacteristicValue",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "key",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "CharacteristicKey",
                  "plural": false,
                  "selections": v0
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "value",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node/*: any*/).hash = '2094a117cdd5904ca9e26d5dbd28ec81';
module.exports = node;



// WEBPACK FOOTER //
// ./src/components/ProductCharacteristics/__generated__/ProductCharacteristics_product.graphql.js